<template>
    <div>
        <v-dialog v-model="loadingContent"
            max-width="250" persistent>
            <v-card class="v-card">
                <v-card-text class="v-card-text">
                    <v-progress-circular class="v-progress-circular"
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                    <div>Aguarde</div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
  name: 'progressDialog',
  props: {
    loadingContent: Boolean,
  },
};
</script>
<style scoped>
    .v-card {
      text-align: center;
      padding: 30px;
    }
    .v-card-text {
        position: relative;
        display: contents;
    }
    .v-card-text .v-progress-circular {
        width: 100%;
    }
    .v-card-text div {
      margin-top: 10px;
      width: 100%;
    }
</style>
